module.exports = {
	"name": "fireadmin",
	"version": "12.0.2",
	"private": true,
	"dependencies": {
		"@tinymce/tinymce-react": "3.0.1",
		"circular-json": "0.5.9",
		"copy-to-clipboard": "^3.2.0",
		"dotenv": "^8.2.0",
		"draft-js": "0.10.1",
		"draft-js-import-html": "^1.3.3",
		"draftjs-to-html": "0.7.2",
		"file-saver": "^2.0.1",
		"firebase": "6.0.4",
		"firebase-admin": "^8.9.2",
		"halogen": "0.2.0",
		"html-to-draftjs": "1.4.0",
		"http": "0.0.0",
		"jquery": "^3.4.1",
		"js-file-download": "0.4.1",
		"json2csv": "^4.5.0",
		"jsoneditor": "^5.32.5",
		"jszip": "^3.2.1",
		"match-sorter": "2.3.0",
		"md5": "2.2.1",
		"mobidonia-firebase-paginator": "1.1.1",
		"moment": "2.23.0",
		"qrcode.react": "^0.9.3",
		"querystring": "^0.2.0",
		"radio-song": "^0.1.8",
		"react": "15.4.2",
		"react-color": "2.13.5",
		"react-datetime": "2.15.0",
		"react-dom": "15.4.2",
		"react-draft-wysiwyg": "1.10.4",
		"react-dropzone": "9.0.0",
		"react-flags-select": "1.1.10",
		"react-google-maps": "9.2.2",
		"react-icons": "3.1.0",
		"react-localize-redux": "3.5.1",
		"react-router": "3.0.2",
		"react-select": "^2.4.3",
		"react-selectable-fast": "2.1.2",
		"react-skylight": "0.4.2",
		"react-sortable-hoc": "0.6.8",
		"react-sortable-tree": "2.2.0",
		"react-table": "6.8.6",
		"recompose": "0.26.0",
		"superagent": "3.5.1",
		"to-case": "2.0.0"
	},
	"devDependencies": {
		"chalk": "^2.4.2",
		"commander": "^2.20.0",
		"generate-json-webpack-plugin": "^0.3.1",
		"inquirer": "^6.3.1",
		"netlify-lambda": "^1.6.3",
		"react-scripts": "0.9.5",
		"replace-in-file": "^4.1.0"
	},
	"scripts": {
		"start": "react-scripts start",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject",
		"build:netlify": "node fillenv.js && npm run build:cloud",
		"build:cloud": "npm run build && npm run build:server && cd dist/server/ && npm install",
		"start:server": "netlify-lambda serve src/lambda -c webpack.server.js",
		"build:server": "netlify-lambda build src/lambda -c webpack.server.js",
		"gitpush": "git push https://github.com/dimovdaniel/builder_site.git"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 996
// module chunks = 0